(function () {
  var MOBILE_QUERY = window.matchMedia('(max-width: 798px)');

  function initProductRitualStickyAtc() {
    var formBlock = document.querySelector('.product-ritual-mobile-zone--form');
    var stickyBar = document.getElementById('product-ritual-sticky-atc');
    var stickyButton = document.querySelector('[data-product-ritual-sticky-atc]');
    var mainButton = document.querySelector('.product-ritual-mobile-zone--form .add_to_cart');

    if (!formBlock || !stickyBar || !stickyButton || !mainButton) {
      return;
    }

    function setStickyVisible(isVisible) {
      stickyBar.hidden = !isVisible;
      stickyBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      stickyBar.classList.toggle('is-visible', isVisible);
      document.body.classList.toggle('product-ritual-sticky-atc-visible', isVisible);
    }

    function syncDisabledState() {
      stickyButton.disabled = mainButton.disabled;
    }

    stickyButton.addEventListener('click', function () {
      if (mainButton.disabled) {
        return;
      }

      mainButton.click();
    });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(syncDisabledState);
      observer.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }

    syncDisabledState();

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var visibilityObserver = new IntersectionObserver(
      function (entries) {
        if (!MOBILE_QUERY.matches) {
          setStickyVisible(false);
          return;
        }

        setStickyVisible(!entries[0].isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -72px 0px',
      }
    );

    function bindObserver() {
      visibilityObserver.disconnect();

      if (MOBILE_QUERY.matches) {
        setStickyVisible(false);
        visibilityObserver.observe(formBlock);
      } else {
        setStickyVisible(false);
      }
    }

    bindObserver();

    if (typeof MOBILE_QUERY.addEventListener === 'function') {
      MOBILE_QUERY.addEventListener('change', bindObserver);
    } else if (typeof MOBILE_QUERY.addListener === 'function') {
      MOBILE_QUERY.addListener(bindObserver);
    }
  }

  function openFlipbookModal() {
    var modal = document.getElementById('flipbookModal');
    if (modal) {
      modal.style.display = 'block';
      document.body.classList.add('flipbook-modal-open');
    }
  }

  function closeFlipbookModal() {
    var modal = document.getElementById('flipbookModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.classList.remove('flipbook-modal-open');
    }
  }

  function initProductRitualFlipbook() {
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('.open-flipbook');
        if (!trigger) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        openFlipbookModal();
      },
      true
    );

    var closeBtn = document.getElementById('closeFlipbook');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeFlipbookModal);
    }

    window.addEventListener('click', function (event) {
      var modal = document.getElementById('flipbookModal');
      if (event.target === modal) {
        closeFlipbookModal();
      }
    });

    if (typeof jQuery === 'undefined') {
      return;
    }

    jQuery('.product-ritual .js-product-gallery').each(function () {
      var $gallery = jQuery(this);
      $gallery.on('staticClick.flickity', function (_event, _pointer, cellElement) {
        if (cellElement && cellElement.querySelector('.open-flipbook')) {
          openFlipbookModal();
        }
      });
    });
  }

  function initProductRitual() {
    initProductRitualStickyAtc();
    initProductRitualFlipbook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRitual);
  } else {
    initProductRitual();
  }
})();
